import { jsx as _jsx } from "react/jsx-runtime";
import { H5 } from 'syf-component-library/ui/typography';
const IntroHeading = ({ children, dataCy = 'intro-heading', weight }) => {
    return (_jsx(H5, Object.assign({ as: "h2", "data-cy": dataCy, weight: weight }, { children: children })));
};
export default IntroHeading;
